export interface IPhone
{
    id: number;
    phoneNumber:string;
    e164PhoneNumber:string;
    phoneType:number;
    smsCapable:boolean;
}

export class Phone implements IPhone
{
    constructor
    (
        public id: number,
        public phoneNumber:string,
        public e164PhoneNumber:string,
        public phoneType:number,
        public smsCapable:boolean,
    )
    {}
}

export class PhoneInsert
{
    constructor
    (
        phone: IPhone
    )
    {
        var numsOnly=phone.phoneNumber.replace(/\D/g, "").trim();
        var phoneNumber = numsOnly.substring(0,10);
        var extension = numsOnly.length > 10 ? numsOnly.substring(11,numsOnly.length) : undefined;

        this.phoneType = phone.phoneType;
        this.countryCode = "001";
        this.phoneNumber = phoneNumber;
        this.smsCapable = phone.smsCapable;
        this.extension = extension;
    }

    phoneType:number;
    countryCode: string;
    phoneNumber:string;
    smsCapable: boolean;
    extension?:string;
}

export class PhoneUpdate
{
    constructor
    (
        public id: number,
        public phoneType?:number,
        public countryCode?: string,
        public phoneNumber?:string,
        public smsCapable?: boolean,
        public extension?:string,
        public clearExtension: boolean = false
    )
    {}
}
